import React, { createContext, useState, } from 'react';
export var OrderContext = createContext({
    currentDrawer: '',
    setCurrentDrawer: function () { return null; },
    showDrawerError: null,
    setShowDrawerError: function () { return null; },
    showExcludedShipStateApiError: {},
    setExcludedShipStateApiError: function () { return null; },
    showReasonCodesApiError: {},
    setReasonCodesApiError: function () { return null; },
    cancellationReasonCodes: [],
    setCancellationReasonCodes: function () { return null; },
    deliveryAddresses: [],
    setDeliveryAddresses: function () { return null; },
    showDeliveryAddressesApiError: {},
    setDeliveryAddressesApiError: function () { return null; },
    availableDeliverySlotsResponse: null,
    setAvailableDeliverySlotsResponse: function () { return null; },
    showDeliveryAvailableSlotsApiError: {},
    setDeliveryAvailableSlotsApiError: function () { return null; },
    deliveryInstructions: null,
    setDeliveryInstructions: function () { return null; },
    requireSignature: false,
    setRequireSignature: function () { return null; },
    selectedDateId: null,
    setSelectedDateId: function () { return null; },
    availableDeliverySlots: [],
    setAvailableDeliverySlots: function () { return null; },
    showCalendar: false,
    setShowCalendar: function () { return null; },
    selectedDeliverySlot: null,
    setSelectedDeliverySlot: function () { return null; },
    deliveryDate: '',
    setDeliveryDate: function () { return null; },
    orderDetailsData: {},
    setOrderDetailsData: function () { return null; },
    orderId: '',
    setOrderId: function () { return undefined; },
    customerType: undefined,
    setCustomerType: function () { return undefined; },
    isEligible: false,
    setIsEligible: function () { return null; },
    isEligibilityChecked: false,
    setIsEligibilityChecked: function () { return null; },
    selectedAddressId: '',
    setSelectedAddressId: function () { return null; },
    fulfillmentOptionsResponse: null,
    setFulfillmentOptionsResponse: function () { return null; },
});
export var OrderProvider = function (_a) {
    var children = _a.children;
    var _b = useState(''), currentDrawer = _b[0], setCurrentDrawer = _b[1];
    var _c = useState(null), showDrawerError = _c[0], setShowDrawerError = _c[1];
    var _d = useState({}), showExcludedShipStateApiError = _d[0], setExcludedShipStateApiError = _d[1];
    var _e = useState({}), showReasonCodesApiError = _e[0], setReasonCodesApiError = _e[1];
    var _f = useState([]), cancellationReasonCodes = _f[0], setCancellationReasonCodes = _f[1];
    var _g = useState([]), deliveryAddresses = _g[0], setDeliveryAddresses = _g[1];
    var _h = useState({}), showDeliveryAddressesApiError = _h[0], setDeliveryAddressesApiError = _h[1];
    var _j = useState(null), availableDeliverySlotsResponse = _j[0], setAvailableDeliverySlotsResponse = _j[1];
    var _k = useState({}), showDeliveryAvailableSlotsApiError = _k[0], setDeliveryAvailableSlotsApiError = _k[1];
    var _l = useState(null), deliveryInstructions = _l[0], setDeliveryInstructions = _l[1];
    var _m = useState(false), requireSignature = _m[0], setRequireSignature = _m[1];
    var _o = useState([]), availableDeliverySlots = _o[0], setAvailableDeliverySlots = _o[1];
    var _p = useState(null), selectedDateId = _p[0], setSelectedDateId = _p[1];
    var _q = useState(false), showCalendar = _q[0], setShowCalendar = _q[1];
    var _r = useState(null), selectedDeliverySlot = _r[0], setSelectedDeliverySlot = _r[1];
    var _s = useState(''), deliveryDate = _s[0], setDeliveryDate = _s[1];
    var _t = useState({}), orderDetailsData = _t[0], setOrderDetailsData = _t[1];
    var _u = useState(undefined), orderId = _u[0], setOrderId = _u[1];
    var _v = useState(undefined), customerType = _v[0], setCustomerType = _v[1];
    var _w = useState(false), isEligible = _w[0], setIsEligible = _w[1];
    var _x = useState(false), isEligibilityChecked = _x[0], setIsEligibilityChecked = _x[1];
    var _y = useState(''), selectedAddressId = _y[0], setSelectedAddressId = _y[1];
    var _z = useState(null), fulfillmentOptionsResponse = _z[0], setFulfillmentOptionsResponse = _z[1];
    return (React.createElement(OrderContext.Provider, { value: {
            currentDrawer: currentDrawer,
            setCurrentDrawer: setCurrentDrawer,
            showDrawerError: showDrawerError,
            setShowDrawerError: setShowDrawerError,
            showExcludedShipStateApiError: showExcludedShipStateApiError,
            setExcludedShipStateApiError: setExcludedShipStateApiError,
            showReasonCodesApiError: showReasonCodesApiError,
            setReasonCodesApiError: setReasonCodesApiError,
            cancellationReasonCodes: cancellationReasonCodes,
            setCancellationReasonCodes: setCancellationReasonCodes,
            deliveryAddresses: deliveryAddresses,
            setDeliveryAddresses: setDeliveryAddresses,
            showDeliveryAddressesApiError: showDeliveryAddressesApiError,
            setDeliveryAddressesApiError: setDeliveryAddressesApiError,
            availableDeliverySlotsResponse: availableDeliverySlotsResponse,
            setAvailableDeliverySlotsResponse: setAvailableDeliverySlotsResponse,
            showDeliveryAvailableSlotsApiError: showDeliveryAvailableSlotsApiError,
            setDeliveryAvailableSlotsApiError: setDeliveryAvailableSlotsApiError,
            deliveryInstructions: deliveryInstructions,
            setDeliveryInstructions: setDeliveryInstructions,
            requireSignature: requireSignature,
            setRequireSignature: setRequireSignature,
            selectedDateId: selectedDateId,
            setSelectedDateId: setSelectedDateId,
            availableDeliverySlots: availableDeliverySlots,
            setAvailableDeliverySlots: setAvailableDeliverySlots,
            showCalendar: showCalendar,
            setShowCalendar: setShowCalendar,
            selectedDeliverySlot: selectedDeliverySlot,
            setSelectedDeliverySlot: setSelectedDeliverySlot,
            deliveryDate: deliveryDate,
            setDeliveryDate: setDeliveryDate,
            orderDetailsData: orderDetailsData,
            setOrderDetailsData: setOrderDetailsData,
            orderId: orderId,
            setOrderId: setOrderId,
            customerType: customerType,
            setCustomerType: setCustomerType,
            isEligible: isEligible,
            setIsEligible: setIsEligible,
            isEligibilityChecked: isEligibilityChecked,
            setIsEligibilityChecked: setIsEligibilityChecked,
            selectedAddressId: selectedAddressId,
            setSelectedAddressId: setSelectedAddressId,
            fulfillmentOptionsResponse: fulfillmentOptionsResponse,
            setFulfillmentOptionsResponse: setFulfillmentOptionsResponse,
        } }, children));
};
